export type LeaseEndUrgency = "default" | "warning" | "danger";

const MS_PER_DAY = 24 * 60 * 60 * 1000;
const DAYS_IN_THREE_MONTHS = 90;
const DAYS_IN_SIX_MONTHS = 180;

function startOfLocalDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

/**
 * Color urgency for an active lease end date.
 * - danger (red): within 3 months (or already past)
 * - warning (yellow): within 6 months
 * - default: more than 6 months away
 * Returns null when there is no usable end date.
 */
export function getLeaseEndUrgency(
  endDate: string | null | undefined
): LeaseEndUrgency | null {
  const trimmed = endDate?.trim();
  if (!trimmed) return null;

  const end = startOfLocalDay(new Date(trimmed));
  if (Number.isNaN(end.getTime())) return null;

  const today = startOfLocalDay(new Date());
  const daysUntilEnd = Math.round((end.getTime() - today.getTime()) / MS_PER_DAY);

  if (daysUntilEnd <= DAYS_IN_THREE_MONTHS) return "danger";
  if (daysUntilEnd <= DAYS_IN_SIX_MONTHS) return "warning";
  return "default";
}
